import styled from '@emotion/styled';

const StarSymbol = styled.span(({ theme }) => ({
  '&::after': {
    content: '"~"',
    color: theme.color.primary,
    fontSize: theme.fontSize.default
  }
}));

export default StarSymbol;
